import { connect } from '../../../../../react-redux';
import { setSidebarStimulusIsShowing } from '../../../../../actions/sidebar';
import Summary from './presenter';
export default connect(null, {
  setSidebarStimulusIsShowing: setSidebarStimulusIsShowing
})(Summary);